import React, { useState, useContext } from "react";
import axios from "axios";
import { ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem, Modal, ModalHeader, ModalBody, ModalFooter, Button, UncontrolledTooltip, CustomInput} from "reactstrap";
import { Link } from "react-router-dom";
import { getCookie } from "../jwt/_helpers/cookie";
import { StateContext } from "../utils/context";
import { getUser } from "../utils/getUser";
import { Trans, useTranslation } from "react-i18next";
import flaggedContentPng from "../assets/images/flaggedContent.png"
import EscrowPaymentModal from "./escrowPaymentModal";

const API_URL = process.env.REACT_APP_API_URL_BASE;
const X_API_KEY = process.env.REACT_APP_X_API_KEY;

const ReleaseDropdown = ({
  id,
  ean,
  status,
  action,
  todUrl,
  touUrl,
  ppUrl,
  canAddTakedown,
  has_delivery_confirmations,
  all_tracks_ready,
  has_blacklisted_artist,
  name,
  has_flagged_tracks,
  flagged_tracks,
  is_light_whitelisted,
  escrow_payment_declined,
  preScanEnabled,
  pre_scan_done,
  pre_scan_status,
  pre_scan,
}) => {
  const tokenAPI = getCookie("token");
  const {currentUser, setCurrentUser} = useContext(StateContext);
  const {t} = useTranslation();
  const {setSuccessAction, forceUpdate, setForceUpdate} = action;
  const [dropdownOpen, setOpen] = useState(false);
  const toggle = () => setOpen(!dropdownOpen);

  const [openDistribute, setOpenDistribute] = useState(false);
  const [openFinishEditing, setOpenFinishEditing] = useState(false);
  const [openTakeDown, setOpenTakeDown] = useState(false);
  const [artificialStreamingDeclaration, artificialStreamingDeclarationSET] = useState(false);
  const [distributedModals, setDistributeModals] = useState({type: null, isOpen: false})
  const [escrowPaymentModalOpen, setEscrowPaymentModalOpen] = useState(false);
  const hasTokensForRedelivery = (currentUser.tokens || 0) > 0;

  const preScanDeclarationRequired = pre_scan_done && pre_scan.alert && pre_scan.scanned_tracks;
  const preScanDeclarationSubmitted = pre_scan && pre_scan.admin_declaration;
  const distributionDisabledPreScanNotDone = (preScanEnabled && !pre_scan_done);
  const distributionDisabledPreScanInProgress = (preScanEnabled && pre_scan_done && pre_scan_status === "in_progress");
  const distributionDisabledPreScanDeclarationNotSubmitted = (preScanEnabled && pre_scan_status === "completed" && preScanDeclarationRequired && !preScanDeclarationSubmitted);
  
  const toggleescrowPaymentModal = () => setEscrowPaymentModalOpen(!escrowPaymentModalOpen);

  const patchRelease = (ID, status, func) => {
    axios({
      method: "patch",
      mode: 'cors',
      url: `${API_URL}releases/${ID}/`,
      data:{
        "status": status
      },
      headers: {
        Authorization: `Bearer ${tokenAPI}`,
        "x-api-key": X_API_KEY,
        "Content-Type": "application/json"
      }
    }).then(function(response) {
      if (response.status === 200) {
        getUser(tokenAPI, currentUser, setCurrentUser);
        setSuccessAction(true);
        setForceUpdate(forceUpdate + 1);
        if (func){
          func();
        }

        setTimeout(() => {
          setSuccessAction(false);
        }, (3000));
      }
    });
  }

// BE VALUES - API Pretty Values
// offline - Offline
// takedown_request - Takedown requested
// taken_down - Taken down
// re_delivery-delivery - Re-delivery
// ready - Ready
// approval - Submission Queued
// locked - In Progress - Locked
// delivering - Delivering
// unlocked - Please Edit
// distributed - Distributed
// live - Live

  return (
    <>
    <ButtonDropdown isOpen={dropdownOpen} toggle={toggle}>
      <DropdownToggle caret outline color="primary">
        {t("releases.view.table.dropdown.item.action")}
      </DropdownToggle>
      {
        status === "distributed" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "release"})}>{t("releases.view.table.dropdown.item.editReleaseMetadata")}</DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "tracks"})}>{t("releases.view.table.dropdown.item.editTracks")}</DropdownItem>
          {canAddTakedown && <DropdownItem onClick={() => setOpenTakeDown(true)}>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {has_delivery_confirmations && <DropdownItem><Link to={`/releases/${id}/delivered-list/`}>{t("releases.view.table.dropdown.item.deliveredList")}</Link></DropdownItem>}
          {!has_delivery_confirmations && <DropdownItem disabled>{t("releases.view.table.dropdown.item.deliveredList")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "locked" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editReleaseMetadata")}
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editTracks")}
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "delivering" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editReleaseMetadata")}
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editTracks")}
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "unlocked" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "release"})}>{t("releases.view.table.dropdown.item.editReleaseMetadata")}</DropdownItem>
          <DropdownItem onClick={() => setDistributeModals({isOpen: true, type: "tracks"})}>{t("releases.view.table.dropdown.item.editTracks")}</DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }

      {
        status === "ready" && (
        <DropdownMenu>
          <DropdownItem 
            onClick={() => {
              if(has_flagged_tracks && !is_light_whitelisted && !escrow_payment_declined) {
                setEscrowPaymentModalOpen(true);
              } else {
                setOpenDistribute(true);
              }
            }}
            disabled={!all_tracks_ready || (!currentUser.is_sub_user && !currentUser.identity_checked) || has_blacklisted_artist  || distributionDisabledPreScanInProgress || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted}
            id={`resdis-tooltip-id-${id}`}
          >
            {t("releases.view.table.dropdown.item.distribute")}
          </DropdownItem>

          {(!all_tracks_ready || (!currentUser.is_sub_user && !currentUser.identity_checked) || has_blacklisted_artist  || distributionDisabledPreScanInProgress || distributionDisabledPreScanNotDone || distributionDisabledPreScanDeclarationNotSubmitted) && (
            <UncontrolledTooltip
              placement="top"
              trigger="hover"
              target={`resdis-tooltip-id-${id}`}
            >
              {
                (has_blacklisted_artist) && <>
                  {t("releases.view.table.dropdown.message.blacklistedArtistTooltip")}
                  <br/><br/>
                </>
              }

              {
                (!currentUser.is_sub_user && !currentUser.identity_checked && !has_blacklisted_artist) && <>
                  {t("releases.view.table.dropdown.message.submitInformationTooltip")}
                  <br/><br/>
                </>
              }

              {
                (distributionDisabledPreScanInProgress) && <>
                  {t("releases.view.table.dropdown.message.distributionDisabledPreScanInProgress")}
                  <br/><br/>
                </>
              }

              {
                (distributionDisabledPreScanNotDone) && <>
                  {t("releases.view.table.dropdown.message.distributionDisabledPreScanNotDone")}
                  <br/><br/>
                </>
              }

              {
                (distributionDisabledPreScanDeclarationNotSubmitted) && <>
                  {t("releases.view.table.dropdown.message.distributionDisabledPreScanDeclarationNotSubmitted")}
                  <br/><br/>
                </>
              }

              {
                (!all_tracks_ready && !has_blacklisted_artist) && <>
                  {t("releases.view.table.dropdown.message.submitMetadataTooltip")}
                  <br/><br/>
                </>
              }
            </UncontrolledTooltip>
          )}

          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>{t("releases.view.table.dropdown.item.editReleaseMetadata")}</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/tracks/`}>{t("releases.view.table.dropdown.item.editTracks")}</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "approval" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editReleaseMetadata")}
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editTracks")}
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "re_delivery-delivery" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editReleaseMetadata")}
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editTracks")}
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "re_delivery-editing" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>{t("releases.view.table.dropdown.item.editReleaseMetadata")}</Link>
          </DropdownItem>
          <span id={`resse-tooltip-id-${id}`}>
            <DropdownItem
              disabled={!all_tracks_ready || !hasTokensForRedelivery}
              onClick={() => {
                setOpenFinishEditing(true)
              }}
            >
              {t("releases.view.table.dropdown.item.submitEditing")}
            </DropdownItem>
          </span>
          {(!all_tracks_ready || !hasTokensForRedelivery) && (
            <UncontrolledTooltip
              placement="top"
              trigger="hover focus"
              target={`resse-tooltip-id-${id}`}
            >
              {!all_tracks_ready && (
                <>
                  {t("releases.view.table.dropdown.message.submitEditingMetadataTooltip")}
                  <br />
                </>
              )}
              {!hasTokensForRedelivery && (
                <>
                  <Trans i18nKey="releases.view.table.dropdown.message.submitEditingTokenRequiredTooltip">
                    At least 1 token is required to submit editing for re-delivery.{" "}
                    <a href="/tokens/order" style={{ color: "#ffffff", textDecoration: "underline" }}>
                      Order tokens
                    </a>.
                  </Trans>
                </>
              )}
            </UncontrolledTooltip>
          )}
          <DropdownItem>
            <Link to={`/releases/${id}/tracks/`}>{t("releases.view.table.dropdown.item.editTracks")}</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "takedown_request" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editReleaseMetadata")}
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editTracks")}
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "taken_down" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editReleaseMetadata")}
          </DropdownItem>
          <DropdownItem disabled>
            {t("releases.view.table.dropdown.item.editTracks")}
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }
      {
        status === "offline" && (
        <DropdownMenu>
          <DropdownItem disabled>{t("releases.view.table.dropdown.item.distribute")}</DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/view/`}>{t("releases.view.table.dropdown.item.viewRelease")}</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/update/`}>{t("releases.view.table.dropdown.item.editReleaseMetadata")}</Link>
          </DropdownItem>
          <DropdownItem>
            <Link to={`/releases/${id}/tracks/`}>{t("releases.view.table.dropdown.item.editTracks")}</Link>
          </DropdownItem>
          {canAddTakedown && <DropdownItem disabled>{t("releases.view.table.dropdown.item.takedown")}</DropdownItem>}
          {ean && <DropdownItem style={{ cursor: "pointer" }} onClick={() => { navigator.clipboard.writeText(ean)}}>{t("releases.view.table.dropdown.item.copyEanUpc")}</DropdownItem>}
        </DropdownMenu>
        )
      }
    </ButtonDropdown>


    <Modal isOpen={distributedModals.isOpen} centered={true}>
      <ModalHeader>{t("releases.view.table.dropdown.modal.editMetadata.header")}</ModalHeader>
      <ModalBody>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.editMetadata.description.point1"><strong>This will change your metadata and can affect the release.</strong></Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.editMetadata.description.point2">Proceed only if you are completely sure.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.editMetadata.description.point3"><strong>PLEASE DO NOT</strong> edit metadata just for testing and exploring.</Trans></p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setDistributeModals({isOpen: false, type: null})}>
          {t("releases.view.table.dropdown.modal.editMetadata.button.cancel")}
        </Button>
        <Button color="success">
          {
            distributedModals.type === 'tracks' ?
            <Link to={`/releases/${id}/tracks`}>{t("releases.view.table.dropdown.modal.editMetadata.button.confirm")}</Link>
            :
            <Link to={`/releases/${id}/update/`}>{t("releases.view.table.dropdown.modal.editMetadata.button.confirm")}</Link>
          }
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={openDistribute} centered={true} style={{ maxWidth: '70%' }}>
      <ModalHeader>{t("releases.view.table.dropdown.modal.distribute.header")}</ModalHeader>
      <ModalBody>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.point1">After this action, your release will be checked and if the information is correct it will be distributed on the official and exclusive distribution dates.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.point2">By confirming and accepting this form, you are fully accepting and complying with the <a href={todUrl} target="blank" rel="noopener noreferrer">Terms Of Distribution</a>, <a href={touUrl} target="blank" rel="noopener noreferrer">Terms Of Use</a> and <a href={ppUrl} target="blank" rel="noopener noreferrer">Privacy Policy</a>.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.point3">By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.point4">Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute. </Trans></p>

          {
            (has_flagged_tracks && !is_light_whitelisted) &&
            <div
              style={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: '1rem',
                flexWrap: 'wrap'
              }}
            >
              <div style={{ flex: '1 1 300px' }}>
                <h6><u>{t("releases.view.table.dropdown.modal.distribute.description.flaggedTracksTerms.header")}</u></h6>
                <Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.flaggedTracksTerms.point1" values={{ releaseName: name }}>
                  Please note: <strong>"{name}"</strong> contains one or more flagged tracks, A fee of <strong>15 €</strong> per flagged track applies in order to deliver the release to <strong>Spotify</strong>. As you have opted not to pay this fee at this time, the release will not be delivered to Spotify. By confirming and accepting this form, you acknowledge and accept these terms.
                </Trans>
                <br/><br/>

                <Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.flaggedTracksTerms.point2">
                  In future if you opt for the release to be delivered to <strong>Spotify</strong> you can go to the Flagged section in Releases table and follow the payment prompts.
                </Trans>
              </div>

              <div style={{ flex: '1 1 300px' }}>
                <img
                  alt="flagged content"
                  src={flaggedContentPng}
                  style={{
                    display: 'block',
                    margin: '0 auto',
                    maxWidth: '100%',
                    height: 'auto',      
                    maxHeight: '200px',
                  }}
                />
              </div>
            </div>
          }

          <div className="mt-4">
            <h6><u>{t("releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.header")}</u></h6>
            <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.point1"><strong>1.</strong> I fully understand and agree not to engage in any form of artificial streaming, including the use of bots, streaming farms, or any method that manipulates DSP metrics.</Trans></p>
            <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.point2"><strong>2.</strong> I will not pay or offer payment for playlist placements, nor will I work with any third party promising guaranteed placements — I understand this is considered fraud and a scam.</Trans></p>
            <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.point3"><strong>3.</strong> I acknowledge that any such actions may result in immediate termination, forfeiture of royalties, legal claims, contractual penalties and fees, and reporting to DSPs and authorities.</Trans></p>
            <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.point4"><strong>4.</strong> I also guarantee to inform and educate any artists or clients I work with about these rules and ensure they comply.</Trans></p>
            <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.point5"><strong>5.</strong> I understand that if I engage in artificial streaming, my KYC data, including my full name, address, ID card, and other personal information, can be shared with the DSP's legal departments, such as those of Spotify, Apple Music, and others.</Trans></p>
            <p><Trans i18nKey="releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.point6"><strong>6.</strong> I accept full legal responsibility for any violations.</Trans></p>

            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
              <CustomInput
                type="checkbox"
                id="artificialStreamingDeclaration"
                name="artificialStreamingDeclaration"
                checked={artificialStreamingDeclaration}
                value={artificialStreamingDeclaration}
                onChange={(e) => { artificialStreamingDeclarationSET(!artificialStreamingDeclaration)}}
              />
              <h6 className="mt-2">
                {t("releases.view.table.dropdown.modal.distribute.description.artificialStreamingDeclaration.acknowledgment")}
              </h6>
            </div>
          </div>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenDistribute(false)}>
          {t("releases.view.table.dropdown.modal.distribute.button.cancel")}
        </Button>
        <Button color="success" onClick={() => patchRelease(id, 'approval', setOpenDistribute(false))} disabled={!artificialStreamingDeclaration}>
          {t("releases.view.table.dropdown.modal.distribute.button.confirm")}
        </Button>
      </ModalFooter>
    </Modal>

    <EscrowPaymentModal
      modalOpen={escrowPaymentModalOpen}
      setModalOpen={setEscrowPaymentModalOpen}
      toggleModal={toggleescrowPaymentModal}
      id={id}
      name={name}
      flagged_tracks={flagged_tracks}
      escrow_payment_declined={escrow_payment_declined}
      forceUpdate={forceUpdate}
      setForceUpdate={setForceUpdate}
      openDistributeModal={true}
      setOpenDistributeModal={setOpenDistribute}
    />

    <Modal isOpen={openTakeDown} centered={true}>
      <ModalHeader>{t("releases.view.table.dropdown.modal.takedown.header")}</ModalHeader>
      <ModalBody>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.takedown.description.point1">This action is irreversible.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.takedown.description.point2">By taking this release down, you are complying with the <a href={todUrl} target="blank" rel="noopener noreferrer">Terms Of Distribution</a>, <a href={touUrl} target="blank" rel="noopener noreferrer">Terms Of Use</a> and <a href={ppUrl} target="blank" rel="noopener noreferrer">Privacy Policy</a>.</Trans></p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenTakeDown(false)}>
          {t("releases.view.table.dropdown.modal.takedown.button.cancel")}
        </Button>
        <Button color="success" onClick={() => patchRelease(id, 'takedown_request', setOpenTakeDown(false))}>
          {t("releases.view.table.dropdown.modal.takedown.button.confirm")}
        </Button>
      </ModalFooter>
    </Modal>

    <Modal isOpen={openFinishEditing} centered={true}>
      <ModalHeader>{t("releases.view.table.dropdown.modal.finishEditing.header")}</ModalHeader>
      <ModalBody>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.finishEditing.description.point1">After this action, your release will be checked and if the information is correct it will be re-distributed to the DSP partners. <strong>NOTE, only METADATA will be sent to DSP-s, content such as IMAGE and AUDIO files can not be updated this way.</strong></Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.finishEditing.description.point2">By confirming and accepting this form, you are fully accepting and complying with the <a href="/terms-and-conditions" target="_blank">Terms Of Use</a> and Terms of our Exclusive Distribution Agreement.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.finishEditing.description.point3">By confirming and accepting this form, you are fully accepting and complying with the <a href="/privacy-policy" target="_blank">Privacy Policy</a>.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.finishEditing.description.point4">By confirming and accepting this form, you are undisputedly confirming that submitted content release with belonging assets, audio files, and metadata, either belongs exclusively to you or it is fully licensed to your label.</Trans></p>
        <p><Trans i18nKey="releases.view.table.dropdown.modal.finishEditing.description.point5">Hereby you fully accept that you will solely be responsible for any misleading information, unlicensed usage, illegal activity or any kind of dispute.</Trans></p>
      </ModalBody>
      <ModalFooter>
        <Button color="secondary" onClick={() => setOpenFinishEditing(false)}>
          {t("releases.view.table.dropdown.modal.finishEditing.button.cancel")}
        </Button>
        <Button color="success" onClick={() => patchRelease(id, 're_delivery-delivery', setOpenFinishEditing(false))}>
          {t("releases.view.table.dropdown.modal.finishEditing.button.confirm")}
        </Button>
      </ModalFooter>
    </Modal>

    </>
  );
};

export default ReleaseDropdown;
